module.exports = "/_next/static/images/num-5-b063d10c.png";